import { BASE_API_URL } from './const'

export default {
    baseApiUrl: BASE_API_URL,
    tokenCookiesName: 'x-access-token-hippo',
    premium: true
}